// @flow
import type { ID_TYPE } from '../types/common';
import type {
  GATEWAY_TYPE,
  GATEWAYS_FETCH_SUCCESS_TYPE,
  GATEWAYS_FETCH_STARTED_TYPE,
  GATEWAY_CREATE_STARTED_TYPE,
  GATEWAY_CREATE_SUCCESS_TYPE,
  REMOVE_GATEWAY_USER_STARTED_TYPE,
  REMOVE_GATEWAY_USER_SUCCESS_TYPE,
  ADD_GATEWAY_USER_STARTED_TYPE,
  ADD_GATEWAY_USER_SUCCESS_TYPE,
  GATEWAY_USERS_FETCH_STARTED_TYPE,
  GATEWAY_USERS_FETCH_SUCCESS_TYPE,
  UPDATE_GATEWAY_USERS_PAGE_TYPE,
  GATEWAY_SELECTED_TYPE,
  REMOVE_GATEWAY_STARTED_TYPE,
  REMOVE_GATEWAY_SUCCEED_TYPE,
  UPDATE_GATEWAY_ACTION_SUCCEDED_TYPE,
  UPDATE_GATEWAY_ACTION_STARTED_TYPE,
  UPDATE_GATEWAY_STARTED_TYPE,
  UPDATE_GATEWAY_SUCCEDED_TYPE,
  UPDATE_GATEWAY_USERS_SUCCEED_TYPE,
} from '../types/gateways';
import { error } from './common';
import * as types from '../types/gateways';

export const startFetchingGateways = (schoolId: number): GATEWAYS_FETCH_STARTED_TYPE => ({
  type: types.GATEWAYS_FETCH_STARTED,
  payload: schoolId,
});

export const startFetchingGatewayUsers = (
  gatewayId: number,
  filters: Object,
): GATEWAY_USERS_FETCH_STARTED_TYPE => ({
  type: types.GATEWAY_USERS_FETCH_STARTED,
  payload: {
    id: gatewayId,
    filters,
  },
});

export const gatewayUsersFetchSucceed = (
  payload: { id: number, order: Array<number>, key: string},
): GATEWAY_USERS_FETCH_SUCCESS_TYPE => ({
  type: types.GATEWAY_USERS_FETCH_SUCCESS,
  payload,
});

export const updateGatewayUsersPage = (
  gatewayId: number,
  page: ?number,
): UPDATE_GATEWAY_USERS_PAGE_TYPE => ({
  type: types.UPDATE_GATEWAY_USERS_PAGE,
  payload: {
    id: gatewayId,
    page,
  },
});

export const gatewaysFetchSucceed = (
  entities: {[number]: GATEWAY_TYPE},
  order: Array<number>,
): GATEWAYS_FETCH_SUCCESS_TYPE => ({
  type: types.GATEWAYS_FETCH_SUCCESS,
  payload: {
    entities,
    order,
  },
});

export const removeGatewayStart = (id: number): REMOVE_GATEWAY_STARTED_TYPE => ({
  type: types.REMOVE_GATEWAY_STARTED,
  payload: id,
});

export const removeGatewaySuccess = (id: number): REMOVE_GATEWAY_SUCCEED_TYPE => ({
  type: types.REMOVE_GATEWAY_SUCCEED,
  payload: id,
});

export const removeGatewayFailed = error(types.REMOVE_GATEWAY_FAILED);

export const addGatewayUserStarted = (
  id: number,
  user: number,
): ADD_GATEWAY_USER_STARTED_TYPE => ({
  type: types.ADD_GATEWAY_USER_STARTED,
  payload: {
    id,
    user,
  },
});

export const addGatewayUserSuccess = (
  payload: {id: number, users: Array<number>},
): ADD_GATEWAY_USER_SUCCESS_TYPE => ({
  type: types.ADD_GATEWAY_USER_SUCCESS,
  payload,
});

export const removeGatewayUserStarted = (
  id: number,
  user: number,
): REMOVE_GATEWAY_USER_STARTED_TYPE => ({
  type: types.REMOVE_GATEWAY_USER_STARTED,
  payload: {
    id,
    user,
  },
});

export const gatewayCreateStarted = (
  gateway: GATEWAY_TYPE,
): GATEWAY_CREATE_STARTED_TYPE => ({
  type: types.GATEWAY_CREATE_STARTED,
  payload: gateway,
});

export const gatewayCreateSuccess = (
  gateway: GATEWAY_TYPE,
): GATEWAY_CREATE_SUCCESS_TYPE => ({
  type: types.GATEWAY_CREATE_SUCCESS,
  payload: gateway,
});

export const gatewayCreateFailed = error(types.GATEWAY_CREATE_FAILED);

export const removeGatewayUserSuccess = (
  payload: {id: number, users: Array<number>},
): REMOVE_GATEWAY_USER_SUCCESS_TYPE => ({
  type: types.REMOVE_GATEWAY_USER_SUCCESS,
  payload,
});

export const selectGateway = (
  payload: ID_TYPE,
): GATEWAY_SELECTED_TYPE => ({
  type: types.GATEWAY_SELECTED,
  payload,
});

export const updateGatewayActionStart = (id: ID_TYPE, intent: string, action: string): UPDATE_GATEWAY_ACTION_STARTED_TYPE => ({
  type: types.UPDATE_GATEWAY_ACTION_STARTED,
  payload: {
    id,
    intent,
    action,
  },
});


export const updateGatewayActionSucceed = (changes: Object): UPDATE_GATEWAY_ACTION_SUCCEDED_TYPE => ({
  type: types.UPDATE_GATEWAY_ACTION_SUCCEDED,
  payload: changes,
});

export const updateGatewayActionFailed = error(types.UPDATE_GATEWAY_ACTION_FAILED);

export const updateGatewayStart = (gateway: GATEWAY_TYPE): UPDATE_GATEWAY_STARTED_TYPE => ({
  type: types.UPDATE_GATEWAY_STARTED,
  payload: gateway,
});

export const updateGatewaySucceed = (gateway: GATEWAY_TYPE): UPDATE_GATEWAY_SUCCEDED_TYPE => ({
  type: types.UPDATE_GATEWAY_SUCCEDED,
  payload: gateway,
});

export const updateGatewayFailed = error(types.UPDATE_GATEWAY_FAILED);

export const updateGatewayUsers = (
  id: number,
  users: Array<number>,
): UPDATE_GATEWAY_USERS_SUCCEED_TYPE => ({
  type: types.UPDATE_GATEWAY_USERS_SUCCEED,
  payload: {
    id,
    users,
  },
});

export const gatewayFetchFailed = error(types.GATEWAYS_FETCH_FAILED);
export const gatewayUsersFetchFailed = error(types.GATEWAYS_USERS_FETCH_FAILED);
export const addGatewayUsersFetchFailed = error(types.ADD_GATEWAY_USER_FAILED);
export const removeGatewayUsersFetchFailed = error(types.REMOVE_GATEWAY_USER_FAILED);



// WEBPACK FOOTER //
// ./src/scripts/actions/gateways.js